window.helpers = {
    aaa() {
        alert('helpers')
    }
};